export const percentage = (value) => {
    return value + "%";
};



// WEBPACK FOOTER //
// ./src/Assets/components/Utility/filters/number.js